export const OPTIMIZELY_GRAPHQL_BASE_URL = 'https://cg.optimizely.com/content/v2/live?auth=';
export const DEFAULT_FETCH_PARAMS = { headers: { 'Content-Type': 'application/json' } };
